export default __webpack_public_path__ + "static/media/Foto-07.10e780fb.png";